import axios from 'axios';
import {mqttPublish} from "../../../mqttHandler";

export default {
  publishCommand: ({ commit, rootGetters }, payload) => {
    const { topic, message, overlay, cb } = payload;
    const topicToUse = `${topic}/source/${rootGetters['ui/usageId']}`;
    if (overlay) {
      commit('ui/SHOW_OVERLAY', true, { root: true });
    }
    mqttPublish(topicToUse, message)
      .then(() => {
        commit('mqtt/APPEND_COMMAND_TO_HISTORY', payload, { root: true });
        commit('ui/SET_FEEDBACK', { message: "Command sent" }, { root: true });
        if (overlay) {
          commit('ui/HIDE_OVERLAY', true, { root: true });
        }
        if (typeof cb === 'function') {
          try {
            cb(null);
          } catch (e) {
            /* eslint-disable */
            console.log(e);
          }
        }
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
        commit('ui/SET_FEEDBACK', { message: "Command failed", type: "is-danger" }, { root: true });
        if (overlay) {
          commit('ui/HIDE_OVERLAY', true, { root: true });
        }
        if (typeof cb === 'function') {
          try {
            cb(err);
          } catch (e) {
            /* eslint-disable */
            console.log(e);
          }
        }
      });
  },
  saveMQTTAccess: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: "/api/mqtt/access",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: JSON.stringify(payload)
    })
      .then(response => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        commit('mqtt/SET_LOCAL_ACCESS', response.data, { root: true });
      })
      .catch(err => {
        next(err);
        commit('ui/HIDE_OVERLAY', true, { root: true });
      });
  }
};